<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Clearance Dose / Malaria Treatment
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Show a list of Clearance Dose and Malaria Treatment cases and their status.
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="auto">
          <b-form-select v-model="studyPhase" :options="studyPhaseOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-form-select v-model="view" :options="viewOptions"></b-form-select>
        </b-col>
      </b-row>
    </b-container>
    <hr>
    <p class="text-muted">
      Click row to view subject details and contact number.
    </p>

    <b-table
      ref="table"
      striped
      hover
      responsive
      selectable
      select-mode='single'
      :items="myProvider"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @row-selected="onRowSelected"
    >
      <template v-slot:cell(overdue)="data">
          <b-badge variant="danger" v-if="isOverdue(data.item)">overdue</b-badge>
      </template>
    </b-table>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>

    <b-modal id="modal-1" size="lg" scrollable title="Subject Details">
      <b-table
      responsive
      stacked
      :items="modalItems"
      :fields="modalFields"
    ></b-table>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'

import * as moment from 'moment';

export default {
  mixins: [
            DashboardBaseTemplate
  ],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 10,
        perPage: 20
      },
      loading: false,
      search: "",
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      studyPhase: 'Cohort 2',
      studyPhaseOptions: ['Baseline', 'Cohort 1', 'Cohort 2'],
      view: 'clearance-dose',
      viewOptions: [
        {value: 'clearance-dose', text: 'Clearance Dose'},
        {value: 'malaria-treatment', text: 'Malaria Treatment'}
      ],
      modalItems: [],
      modalFields: ['subject_id', 'bloodslide_code', 'telephone_number']
    };
  },
  computed: {},
  watch: {
    view: function() {
      this.$refs.table.refresh();
    },
    studyPhase: function() {
      this.$refs.table.refresh();
    }
  },
  created: function() {
    if('view' in this.$route.params) {
      this.view = this.$route.params.view;
    }
  },
  methods: {
    myProvider(ctx) {
      const that = this;

      return HTTP.get("/kenya/table/clearance-malaria", {
        params: {
          view: that.view,
          page: ctx.currentPage,
          count: ctx.perPage,
          sortBy: that.sortBy,
          sortDesc: that.sortDesc ? "" : "yes",
          study_phase: that.studyPhase
        }
      })
        .then(response => {
          if(that.view == "clearance-dose") {
            that.fields = ['subject_id', 'dose_1_date', 'clearance_dose_complete_date', 'overdue'];
          } else {
            that.fields = ['subject_id', 'dose_1_date', 'malaria_treatment_complete_date', 'overdue'];
          }
          
          that.data = response.data.data;
          that.options.totalRows = response.data.total;
          return that.data;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          return [];
        });
    },
    onRowSelected(items) {
      let that = this;
      
      if(!items.length || !items[0]['subject_id']) {
        return;
      } else {
        // Add subject id here and use it.
       HTTP.get(`/kenya/details/subject/${items[0]['subject_id']}`).then((response) => {
         that.modalItems = [response.data];
          that.$bvModal.show('modal-1');
       });
      }
    },
    isOverdue(row) {
      let date = row.clearance_dose_complete_date ? row.clearance_dose_complete_date : row.malaria_treatment_complete_date;

      if(!date) {
        return (moment().diff(moment(row.dose_1_date), 'days') > 5);
      }

      return false;
    }
  }
};
</script>

<style>
</style>